import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoadingSpinnerComponent } from './loading-spinner.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [CommonModule, FontAwesomeModule],
  declarations: [LoadingSpinnerComponent],
  exports: [LoadingSpinnerComponent],
  entryComponents: [LoadingSpinnerComponent]
})
export class LoadingSpinnerModule {}
